var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.old_session_active)?_c('warning-box',{attrs:{"title":"Session","body":'You still have an active session with name'+this.getRestaurantAuth().name+'. Are you sure want to use another session?',"btn_primary":"Yes","btn_secondary":"No"},on:{"yes":_vm.applySession,"no":_vm.goToHome}}):_c('loader')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eb38c72","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/restaurant/applySession.vue
// module id = null
// module chunks = 